/**
 * Sales module exports
 */

export { SalesPage } from './SalesPage';
